import { render } from "./batchCommentsOrderConfirmModal.vue?vue&type=template&id=503a732e&scoped=true"
import script from "./batchCommentsOrderConfirmModal.vue?vue&type=script&lang=js"
export * from "./batchCommentsOrderConfirmModal.vue?vue&type=script&lang=js"

import "./batchCommentsOrderConfirmModal.vue?vue&type=style&index=0&id=503a732e&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503a732e"]])

export default __exports__